import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import CheckoutService from 'services/checkout/checkout.service';
import { getSummary } from '../getSummary';

export const updateCheckoutItem = createAsyncThunk(
	'updateCheckoutItem',
	async ({ transactionId, changes }, thunkAPI) => {
		const { dispatch, rejectWithValue, fulfillWithValue, signal } = thunkAPI;
		const source = axios.CancelToken.source();
		signal.addEventListener('abort', () => {
			source.cancel();
		});

		try {
			const response = await CheckoutService.instance.updateCheckoutItem(transactionId, changes, source.token);
			if (!signal.aborted) {
				await dispatch(getSummary({}));
			}
			const data = response?.data || response || {};
			return fulfillWithValue({ updatedItem: data.updated_item });
		} catch (error) {
			return rejectWithValue({ error });
		}
	},
);
